package com.vizio.redwolf.utils.clientprovider

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.DefaultRequest

object DefaultClientProvider : ConfigurableClientProvider() {

    override val lazyClientInitDelegate: Lazy<HttpClient> = lazy {
        val clientConfig: HttpClientConfig<*>.() -> Unit = {
            installCoreClientConfig()
            install(DefaultRequest) {
                addSdkHeaders()
            }
        }
        HttpClient(clientConfig)
    }

    override val httpClient: HttpClient by lazyClientInitDelegate

    override fun close() {
        httpClient.close()
    }
}
